import React, { useEffect, useState } from "react";
import {
  roles,
  riderRoles,
  cashierRoles,
  accountantRoles,
  productManagerRoles,
  systemUserRules,
  displayUserRoles,
} from "../../config/config";

const Checkbox = ({ label, value, isChecked, onChange }) => {
  return (
    <div className="flex items-center mr-4">
      <label className="relative flex items-center px-3 rounded-full cursor-pointer">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          value={value}
          className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
        />
        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3.5 w-3.5"
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </span>
      </label>
      {label}
    </div>
  );
};

const SelectAllCheckbox = ({
  handleModuleAccesSelect,
  role,
  module_access,
}) => {
  const modulesAccess = JSON.parse(module_access);
  const [checkboxes, setCheckboxes] = useState(modulesAccess);
  const [selectAll, setSelectAll] = useState(false);
  console.log(modulesAccess);
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setCheckboxes([...checkboxes, e.target.value]);
    } else {
      setCheckboxes(checkboxes.filter((item) => item !== e.target.value));
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    let updatedCheckboxes = [];

    if (isChecked) {
      updatedCheckboxes = roles.map((role) => role.value);
    }

    setCheckboxes(updatedCheckboxes);
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    handleModuleAccesSelect(checkboxes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxes]);

  useEffect(() => {
    setSelectAll(false);
    if (modulesAccess.length === 0) {
      var modules = [];
      if (role === "super_admin") {
        modules = systemUserRules;
        setSelectAll(true);
      } else {
        if (role === "cashier") modules = cashierRoles;
        if (role === "rider") modules = riderRoles;
        if (role === "display_user") modules = displayUserRoles;
        if (role === "accountant") modules = accountantRoles;
        if (role === "product_manager") modules = productManagerRoles;
      }
    }

    setCheckboxes(modules || modulesAccess);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div>
      <div className="flex items-center mr-4">
        <label className="relative flex items-center px-3 rounded-full cursor-pointer">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAllChange}
            className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
          />
          <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3.5 w-3.5"
              viewBox="0 0 20 20"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="1"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </span>
        </label>
        Select All
      </div>
      {/* <div className="cursor-pointer">
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Attendance"
              isChecked={checkboxes[31]}
              onChange={() => handleCheckboxChange(31)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Bar"
              isChecked={checkboxes[30]}
              onChange={() => handleCheckboxChange(30)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Customer"
              isChecked={checkboxes[29]}
              onChange={() => handleCheckboxChange(29)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Customer Due Recieve"
              isChecked={checkboxes[28]}
              onChange={() => handleCheckboxChange(28)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Dashboard"
              isChecked={checkboxes[27]}
              onChange={() => handleCheckboxChange(27)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Discount"
              isChecked={checkboxes[26]}
              onChange={() => handleCheckboxChange(26)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Accounting"
              isChecked={checkboxes[25]}
              onChange={() => handleCheckboxChange(25)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Expense"
              isChecked={checkboxes[24]}
              onChange={() => handleCheckboxChange(24)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Inventory"
              isChecked={checkboxes[23]}
              onChange={() => handleCheckboxChange(23)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Inventory Adjustment"
              isChecked={checkboxes[22]}
              onChange={() => handleCheckboxChange(22)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Items"
              isChecked={checkboxes[21]}
              onChange={() => handleCheckboxChange(21)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Kitchen"
              isChecked={checkboxes[20]}
              onChange={() => handleCheckboxChange(20)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Management"
              isChecked={checkboxes[0]}
              onChange={() => handleCheckboxChange(0)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Purchase"
              isChecked={checkboxes[1]}
              onChange={() => handleCheckboxChange(1)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Reporting"
              isChecked={checkboxes[2]}
              onChange={() => handleCheckboxChange(2)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Setting"
              isChecked={checkboxes[3]}
              onChange={() => handleCheckboxChange(3)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Rider Alert"
              isChecked={checkboxes[4]}
              onChange={() => handleCheckboxChange(4)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="All Sales"
              isChecked={checkboxes[5]}
              onChange={() => handleCheckboxChange(5)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Short Message Service"
              isChecked={checkboxes[6]}
              onChange={() => handleCheckboxChange(6)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Supplier Payment"
              isChecked={checkboxes[7]}
              onChange={() => handleCheckboxChange(7)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="User"
              isChecked={checkboxes[8]}
              onChange={() => handleCheckboxChange(8)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="User Section"
              isChecked={checkboxes[9]}
              onChange={() => handleCheckboxChange(9)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Waiter"
              isChecked={checkboxes[10]}
              onChange={() => handleCheckboxChange(10)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Waste"
              isChecked={checkboxes[11]}
              onChange={() => handleCheckboxChange(11)}
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center text-[#77469d] font-semibold my-2">
          <div className="w-1/2">
            <Checkbox
              label="Web Page"
              isChecked={checkboxes[12]}
              onChange={() => handleCheckboxChange(12)}
            />
          </div>
          <div className="w-1/2">
            <Checkbox
              label="Web Setting"
              isChecked={checkboxes[13]}
              onChange={() => handleCheckboxChange(13)}
            />
          </div>
        </div>
      </div> */}
      <div className="mt-4 grid gap-4 grid-cols-2">
        {roles.map((role, index) => (
          <div className="" key={index}>
            <Checkbox
              label={role.label}
              value={role.value}
              isChecked={checkboxes.includes(role.value)}
              onChange={handleCheckboxChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectAllCheckbox;
